module.exports = __webpack_public_path__ + "static/img/satanizador-3.ba9966a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/satanizador-3.jpg
// module id = jMUl
// module chunks = 1